/**
 * Styled components for SourceListVertical
 */

import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { ocScrollbarStyles } from '../../styles/OcScrollbar.styled';

/**
 * Main container for the vertical source list (25% width)
 */
export const SourceListContainer = styled.div`
  width: 25%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-left: 2px solid rgba(0,0,0,.1);
`;

/**
 * Header showing "Sources (count)"
 */
export const SourceListHeader = styled.div`
  padding: 12px 16px;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: ${({ theme }) => theme.font.weight.bold};
  color: ${({ theme }) => (theme as IOcAppTheme).color.sourcesHeaderCountText || theme.color.chatHeading};
  flex-shrink: 0;
`;

/**
 * Scrollable container for source cards
 */
export const SourceListScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  /* Shared OC scrollbar styling */
  ${ocScrollbarStyles}
`;
